'use strict';

window.addEventListener('scroll', function (event) {
  if (window.scrollY > window.innerHeight) {
    document.querySelector('#to-top').style.display = 'block';
  } else if (window.scrollY < window.innerHeight) {
    document.querySelector('#to-top').style.display = 'none';
  }
});
document.querySelector('#to-top').addEventListener('click', function (event) {
  event.preventDefault();
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth"
  });
});